import {Input, DatePicker } from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import {useState} from "react";

export const ExpForm = ({id,onRemove}) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    return (
        <div className="border rounded-lg p-4 shadow-md w-full">
            {/* Header */}
            <div className="flex justify-between items-center">
                <h2 className="text-lg font-semibold">Kinh nghiệm làm việc</h2>
                <button className="text-red-500 hover:underline" onClick={() => onRemove(id)}>
                    <DeleteOutlined className="mr-1"/> Xóa
                </button>
            </div>

            {/* Inputs */}
            <div className="grid grid-cols-3 gap-4 mt-4">
                <div>
                    <label className="text-sm font-medium">Công ty</label>
                    <Input placeholder="VD: CTy Thép Hòa Phát"/>
                </div>
                <div>
                    <label className="text-sm font-medium">Công việc</label>
                    <Input placeholder="VD: Công nhân"/>
                </div>
                <div>
                    <label className="text-sm font-medium">Chức vụ từng làm</label>
                    <Input placeholder="VD: Nhân viên"/>
                </div>
            </div>

            {/* Date Pickers */}
            <div className="grid grid-cols-2 gap-4 mt-4">
                <div>
                    <label className="text-sm font-medium">Thời gian bắt đầu</label>
                    <DatePicker
                        className="w-full"
                        format="MM/DD/YYYY"
                        value={startDate}
                        onChange={(date) => setStartDate(date)}
                    />
                </div>
                <div>
                    <label className="text-sm font-medium">Thời gian kết thúc</label>
                    <DatePicker
                        className="w-full"
                        format="MM/DD/YYYY"
                        value={endDate}
                        onChange={(date) => setEndDate(date)}
                    />
                </div>
            </div>
        </div>
    );
}